<template>
  <div class="txt">{{ title }}</div>
</template>
<script setup  >

import { ref, onMounted, reactive } from "vue";
import * as echarts from "echarts";
import { useRouter } from "vue-router";
// console.log(props)
const props =defineProps({
  title:{
    type:String,
    default:"市场引领 电商驱动  三产融合 上蔡样板"
  }

})

const state = reactive({

})
const router = useRouter();
// 返回上一页
  onMounted(() => {


  });




</script>
<style lang="less" scoped>
.txt{
  font-size: 40px;
  color:#F3FCFF;
  letter-spacing: 5px;
  font-weight: bold;
  //text-shadow: 5px 0px 5px rgba(13, 89, 82, .9)
  text-shadow:
    0 0 10px rgba(4, 88, 167, 0.5), /* 第一层内发光 */
    0 0 20px rgba(4, 88, 167, 0.8), /* 第二层内发光 */
    0 0 30px rgba(4, 88, 167, 1);   /* 第三层内发光 */
  position: absolute;
  top: 140px;
  left: 120px;
  background: url("../assets/img/sanchan1/7.png") no-repeat left bottom;
  height: 74px;
  padding-left: 60px;
  line-height: 64px;

}
</style>
